import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { SET_BASE } from '#src/set/base/index.ts';

export const useHasLegacyEssence = () => {
  const { currentUser } = useCurrentUserContext();
  return !!currentUser?.cardShardsChests?.some(
    chest => chest.cardSet?.slug === SET_BASE.slug && chest.cardShardsCount > 0
  );
};
